var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LocalTimeIcon } from "./svg/localTime";
import { UtcTimeIcon } from "./svg/utcTime";
import { Box, Typography, Tooltip, Divider } from "@material-ui/core";
import moment from "moment-timezone";
import { memo, useEffect, useState } from "react";
import { useStyles } from "./styles";
var UtcTime = memo(function () {
    var classes = useStyles();
    var _a = useState(moment()), state = _a[0], setState = _a[1];
    useEffect(function () {
        var interval = setInterval(function () {
            setState(moment());
        }, 1000);
        return function () {
            clearInterval(interval);
        };
    }, []);
    return (_jsxs(Box, __assign({ display: "flex", alignItems: "center", justifyContent: "cenetr" }, { children: [_jsx(Tooltip, __assign({ title: moment(state).tz(moment.tz.guess()).format("dddd DD MMMM YYYY") }, { children: _jsxs(Box, __assign({ className: classes.timeStyleLocal }, { children: [_jsx("small", { children: LocalTimeIcon }), _jsx(Typography, __assign({ className: classes.titleTime }, { children: moment(state).tz(moment.tz.guess()).format("HH:mm") }))] })) })), _jsx(Divider, { className: classes.divider }), _jsx(Tooltip, __assign({ title: state.utc().format("dddd DD MMMM YYYY") }, { children: _jsxs(Box, __assign({ className: classes.timeStyleUtc }, { children: [_jsx("small", { children: UtcTimeIcon }), _jsx(Typography, __assign({ className: classes.titleTime }, { children: state.utc().format("HH:mm") }))] })) }))] })));
});
export { UtcTime };
